import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Menu, ArrowRight } from "lucide-react";
import { Logo } from "@/components/Logo";
import ThemeToggle from "@/components/ThemeToggle";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import { useLanguage } from "@/context/LanguageContext";

export default function PublicHeader() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const { t } = useLanguage();

  const nav = [
    { label: t("nav_find_jobs", "Find Jobs"), to: "/#jobs", id: "find-jobs" },
    { label: t("nav_customize_cv", "Customize CV"), to: "/#customize", id: "customize-cv" },
    { label: t("nav_how_it_works", "How It Works"), to: "/#how", id: "how-it-works" },
    { label: t("nav_about", "About Us"), to: "/#about", id: "about" },
    { label: t("nav_compare", "Compare"), to: "/compare", id: "compare" },
    { label: t("nav_pricing", "Pricing"), to: "/pricing", id: "pricing" },
  ];

  return (
    <header className="sticky top-0 z-50 glass border-b border-border/60">
      <div className="cv-container flex h-16 items-center justify-between">
        <Logo />

        <nav className="hidden items-center gap-6 lg:flex">
          {nav.map((n) => (
            <a
              key={n.id}
              href={n.to}
              onClick={(e) => {
                if (n.to.startsWith("/#")) return;
                e.preventDefault();
                navigate(n.to);
              }}
              className="text-sm font-medium text-muted-foreground transition-colors hover:text-foreground"
              data-testid={`nav-${n.id}`}
            >
              {n.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2 sm:gap-3">
          <ThemeToggle />
          <Link
            to="/login"
            className="hidden text-sm font-semibold text-foreground hover:text-electric sm:inline-flex px-3 py-2"
            data-testid="header-login"
          >
            {t("nav_login", "Log In")}
          </Link>
          <Link
            to="/signup"
            className="cv-btn-primary hidden text-sm sm:inline-flex"
            data-testid="header-start-free"
          >
            {t("nav_start_free", "Start Free")} <ArrowRight className="h-4 w-4" />
          </Link>

          <Sheet open={open} onOpenChange={setOpen}>
            <SheetTrigger asChild>
              <button className="lg:hidden rounded-full border border-border p-2" data-testid="mobile-menu-btn" aria-label="Menu">
                <Menu className="h-5 w-5" />
              </button>
            </SheetTrigger>
            <SheetContent side="right" className="w-[85vw] max-w-sm">
              <div className="mt-6 flex flex-col gap-1">
                {nav.map((n) => (
                  <a
                    key={n.id}
                    href={n.to}
                    onClick={() => setOpen(false)}
                    className="rounded-xl px-3 py-3 text-base font-semibold hover:bg-secondary"
                  >
                    {n.label}
                  </a>
                ))}
                <div className="mt-4 flex flex-col gap-3">
                  <Link to="/login" onClick={() => setOpen(false)} className="cv-btn-ghost border border-border">{t("nav_login", "Log In")}</Link>
                  <Link to="/signup" onClick={() => setOpen(false)} className="cv-btn-primary">{t("nav_start_free", "Start Free")}</Link>
                </div>
              </div>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>
  );
}
